import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { SEND_OFFER_FORM } from '../../constants/formNames';
import SendOfferForm from './SendOfferForm';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import Transactable from 'shared-components/flow-transactable/transactable-main';

class SendOfferFormContainer extends Component {
  constructor (props) {
    super(props);

    this.submitOffer = this.submitOffer.bind(this);
    this.handleTSChange = this.handleTSChange.bind(this);
  }

  submitOffer (cb) {
    const { profile, iosWebView } = this.props;
    if (iosWebView) {
      return cb();
    }
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <Transactable
          user={profile}
          intendedAction={cb}
          hostFlag
          snoozeFeature
          zenDeskLocale={SharedIntlProviderHOC.getZendeskLocale()}
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  handleTSChange (value) {
    const { dispatch } = this.props;
    dispatch(change(SEND_OFFER_FORM, 'host_social_events_policy_accepted', value));
  }

  render () {
    return (
      <SendOfferForm
        {...this.props}
        submitOffer={this.submitOffer}
        setIsTSAccepted={this.handleTSChange}
      />
    );
  }
}

SendOfferFormContainer.propTypes = {
  currency: PropTypes.string,
  dispatch: PropTypes.func
};

const selector = formValueSelector(SEND_OFFER_FORM);

function mapStateToProps (state) {
  const { contract, profile } = state;
  const addOns = selector(state, 'add_ons');
  const isTSAccepted = selector(state, 'host_social_events_policy_accepted');
  const isSubmitting = contract.isPosting;
  return {
    addOns,
    isSubmitting,
    contractData: contract,
    errorMessage: contract.error,
    isTSAccepted,
    profile
  };
}

export default connect(mapStateToProps)(SendOfferFormContainer);
